import SharedNavbar from '@/components/feature/SharedNavbar';
import { Seo } from '@/components/Seo';
import SharedFooter from '@/components/feature/SharedFooter';
import HeroBanner from './components/HeroBanner';
import TheProblem from './components/TheProblem';
import OurSolution from './components/OurSolution';
import TheCompany from './components/TheCompany';
import MadeForBangladesh from './components/MadeForBangladesh';
import BrandCTA from './components/BrandCTA';
import { useSiteDesign } from '@/hooks/useSiteDesign';
import BrandStoryV2 from './v2/BrandStoryV2';

export default function BrandStoryPage() {
  const { isNew } = useSiteDesign();
  if (isNew)
    return (
      <main className="w-full min-h-screen bg-white">
        <Seo pageKey="brandStory" />
        <SharedNavbar />
        <div style={{ paddingTop: 'var(--v2h-h, 64px)' }}>
          <BrandStoryV2 />
        </div>
        <SharedFooter />
      </main>
    );
  return (
    <>
      <main className="w-full min-h-screen bg-white font-sans">
        <Seo pageKey="brandStory" />
        <SharedNavbar />
        <HeroBanner />
        <TheProblem />
        <OurSolution />
        <TheCompany />
        <MadeForBangladesh />
        <BrandCTA />
        <SharedFooter />
      </main>
    </>
  );
}
